import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { config } from "../../utils/config";

const BidPage = () => {
  const baseUrl = config.apiUrl;
  const { id } = useParams();
  const [sessions, setSessions] = useState([]);
  const [activeSessionId, setActiveSessionId] = useState(null);
  const [bidValue, setBidValue] = useState("");

  const getAllData = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/getBiddingSessions/${id}`
      );
      if (response?.data?.sessions) {
        setSessions(response.data.sessions);
      }
    } catch (error) {
      console.log("Error ----->", error);
    }
  };

  const handleSubmitBid = async (session) => {
    try {
      if (!bidValue || bidValue <= 0) {
        alert("Please enter valid bid");
        return;
      }

      let payload = {
        transaction_id: session?.transaction_id,
        action: "ACCEPT",
        items: [
          {
            item_id: session?.item_id,
            seller_bid: Number(bidValue),
          },
        ],
      };

      console.log("FINAL PAYLOAD --->", payload);

      await axios.post(
        `${baseUrl}/admin_dashboard_seller_bid_action`,
        payload
      );

      setActiveSessionId(null);
      setBidValue("");

      getAllData();
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  const handleReject = async (session) => {
    try {
      let payload = {
        transaction_id: session?.transaction_id,
        action: "REJECT",
        items: [
          {
            item_id: "",
            seller_bid: "",
          },
        ],
      };

      await axios.post(
        `${baseUrl}/admin_dashboard_seller_bid_action`,
        payload
      );

      getAllData();
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  useEffect(() => {
    if (id) {
      getAllData();
    }
  }, [id]);

  return (
    <div className="container mt-4">
      <div className="row d-flex justify-content-center" >
        {sessions.map((session) => {
          const product = session.product_details;
          const latestBid = session.summary?.latest_bid;
          return (
            <div className="col-md-4 mb-4" key={session.id}>
              <div className="card shadow-sm p-3">
                <b className="text-dark">{product?.name}</b>
                
                <hr />

                <p><b>Base Price:</b> ₹{product?.base_price}</p>
                <p><b>Current Price:</b> ₹{product?.current_price}</p>
                <p><b>Min Price:</b> ₹{product?.minimum_price}</p>

                <hr />

                <p><b>Latest Bid:</b> ₹{latestBid?.seller_bid || "N/A"}</p>
                <p><b>Status:</b> {session.status}</p>
                <p><b>Warehouse:</b> {product?.warehouse_name}</p>
                <p>
                  <b>Location:</b> {product?.city}, {product?.state}
                </p>

                <div className="d-flex mt-2" style={{ gap: "18px" }}>
                  <button
                    className="btn btn-success w-100"
                    onClick={() => {
                      setActiveSessionId(session.id);
                      setBidValue("");
                    }}
                  >
                    Accept
                  </button>

                  <button
                    className="btn btn-danger me-3 w-100"
                    onClick={() => handleReject(session)}
                  >
                    Reject
                  </button>
                </div>

                {activeSessionId === session.id && (
                  <div className="mt-3 d-flex" style={{ gap: "12px" }}>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter bid amount"
                      value={bidValue}
                      onChange={(e) => setBidValue(e.target.value)}
                    />

                    <button
                      className="btn btn-primary w-50"
                      onClick={() => handleSubmitBid(session)}
                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BidPage;
